export const digit = (digit: number) => {
  return digit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const generateRandomString = (digit: number) => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
  let result = '';
  const charactersLength = characters.length;
  for (let i = 0; i < digit; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};
